export default  [
 {
   "templateCategory": 'STANDARD',
   "templateID": 'DEFAULT_TEMPLATE',
   "templateName": "Mood Board",
   "templateQuestion": "What's your Mood Today?",
   "templateDescription": 'Standard Team Mood Board'
 },
 {
   "templateCategory": 'AGILE',
   "templateID": 'SPRINT_PLANNING',
   "templateName": "Sprint Planning",
    "templateQuestion": "How do you feel about the Sprint Backlog?",
   "templateDescription": 'Check how the team feels about the Sprint Backlog.'
 },
 {
   "templateCategory": 'AGILE',
   "templateID": 'DAILY_STANDUP',
   "templateName": "Daily Standup",
  "templateQuestion": "Hows the Sprint going? 🙂 😐 🥵",
   "templateDescription": 'Check on the team\'s well being during the daily standup meeting',
    "checkinQuestions":[
       {"questionID": "DAILY_STANDUP_1","questionText": "What do you plan to achieve today?"},
       {"questionID": "DAILY_STANDUP_2","questionText": "Do you have any Blockers?"},
    ]
 },
 {
   "templateCategory": 'AGILE',
   "templateID": 'SPRINT_REVIEW',
   "templateName": "Sprint Review",
   "templateQuestion": "How do you feel the sprint results?",
   "templateDescription": 'Learn how the team and end users feel about the output of the sprint.',
   "informationFields" : [
     {"infoID":"SPRINT_GOAL","infoText":"sp"},
   ],
 },
 {
   "templateCategory": 'AGILE',
   "templateID": 'SPRINT_RETRO',
   "templateName": "Sprint Retrospective",
   "templateQuestion": "And how was the Sprint? 😃 😐 🥵 ",
   "templateDescription": 'Check how the team is feeling about the latest sprint.',
   "informationFields" : [
     {"infoID":"SPRINT_START","infoText":"Sprint Start"},
     {"infoID":"SPRINT_END","infoText":"Sprint End"},
   ],
   "checkinQuestions":[
     {"questionID": "SPRINT_RETRO_1","questionText": "What Went well?"},
     {"questionID": "SPRINT_RETRO_2","questionText": "What Did Not Go Well?"},
     {"questionID": "SPRINT_RETRO_3","questionText": "What Could Be Improved "}
   ]
 },
 {
   "templateCategory": 'AGILE',
   "templateID": 'SPRINT_RETRO_STARFISH',
   "templateName": "Sprint Retrospective - Starfish",
   "templateQuestion": "And how was the Sprint? 😃 😐 🥵 ",
   "templateDescription": 'Capture what to Keep Doing, Less Of, More Of, Stop Doing, Start Doing',
   "informationFields" : [
     {"infoID":"SPRINT_START","infoText":"Sprint Start"},
     {"infoID":"SPRINT_END","infoText":"Sprint End"},
   ],
   "checkinQuestions":[
     {"questionID": "SPRINT_RETRO_STARFISH_1","questionText": "Keep Doing"},
     {"questionID": "SPRINT_RETRO_STARFISH_2","questionText": "More Of"},
     {"questionID": "SPRINT_RETRO_STARFISH_3","questionText": "Less Of"},
     {"questionID": "SPRINT_RETRO_STARFISH_4","questionText": "Stop Doing"},
     {"questionID": "SPRINT_RETRO_STARFISH_5","questionText": "Start Doing"},
   ]
 },
 {
   "templateCategory": 'AGILE',
   "templateID": 'SPRINT_RETRO_SAILBOAT',
   "templateName": "Sprint Retrospective - Sailboat",
   "templateQuestion": "And how was the Sprint? 😃 😐 🥵 ",
   "templateDescription": '',
   "informationFields" : [
     {"infoID":"SPRINT_START","infoText":"Sprint Start"},
     {"infoID":"SPRINT_END","infoText":"Sprint End"},
   ],
   "checkinQuestions":[
     {"questionID": "SPRINT_RETRO_SAILBOAT_1","questionText": "🏝 Island: What is our destination?"},
     {"questionID": "SPRINT_RETRO_SAILBOAT_2","questionText": "🪨 Rocks: What are the risks?"},
     {"questionID": "SPRINT_RETRO_SAILBOAT_3","questionText": "⚓️ Anchor: what's slowing us down?"},
     {"questionID": "SPRINT_RETRO_SAILBOAT_4","questionText": "💨 Wind: What is pushing us forward?"},
   ]
 }
]
